export enum PageName {
  vendor = 'vendor',
  customer = 'customer',
}
